// Cálculos puros da Visão Executiva (ranking de insights, melhor/pior etapa
// e cor do NPS), extraídos de index.jsx pra testar sem montar o componente.

// Os 3 insights de maior prioridade (menor número = mais prioritário),
// excluindo o insight "Visão Geral" (que não é uma frente acionável).
export function getTop3InsightsByPriority(insightsList) {
  return [...(insightsList || [])]
    .filter((ins) => ins.category !== "Visão Geral")
    .sort((a, b) => {
      const aMatch = a.priority?.match(/\d+/)?.[0];
      const bMatch = b.priority?.match(/\d+/)?.[0];
      const aPrio = aMatch !== undefined ? parseInt(aMatch, 10) : Infinity;
      const bPrio = bMatch !== undefined ? parseInt(bMatch, 10) : Infinity;
      return aPrio - bPrio;
    })
    .slice(0, 3);
}

// Etapa da jornada com o maior valor (ex.: "melhor etapa" do snapshot).
export function maxJourneyMetric(journey) {
  return (
    (journey || [])
      .map((d) => ({ value: d.value, name: d.name }))
      .sort((a, b) => b.value - a.value)[0] || { value: 0, name: "—" }
  );
}

// Etapa da jornada com o menor valor (ex.: "pior etapa" do snapshot).
export function minJourneyMetric(journey) {
  return (
    (journey || [])
      .map((d) => ({ value: d.value, name: d.name }))
      .sort((a, b) => a.value - b.value)[0] || { value: 0, name: "—" }
  );
}

// Cor semântica do NPS, por faixa (-100 a 100).
export function npsColor(v) {
  if (v >= 75) return "#059669";
  if (v >= 50) return "#16a34a";
  if (v >= 0) return "#0284c7";
  if (v >= -25) return "#d97706";
  return "#dc2626";
}
